module Meevo.Plugins.InventoryTransfer {

    class InventoryTransferNoteController {

        static $inject = [
            "meevo.components.common.DataService",
            "meevo.components.modal.ModalService",
            "meevo.components.tracking.TrackingService",
            "$mdDialog",
            "inventoryTransferId",
            "note",
            "transferringLocationId",
            "receivingLocationId",
            "currentLocationId",
            "isCoLocation"
        ];

        public isAdding: boolean;

        constructor(
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            private $mdDialog,
            protected inventoryTransferId: string,
            public note: any,
            protected transferringLocationId: number,
            protected receivingLocationId: number,
            protected currentLocationId: number,
            protected isCoLocation: boolean,
            private preventUsageTracking: boolean) { 

            if ((this.isAdding = !this.note)) {
                this.note = {
                    id: NewGuid(),
                    inventoryTransferId: this.inventoryTransferId,
                    objectstate: Model.ObjectStateEnum.Active,
                    note: "",
                    isLocationTo: false,
                    isLocationFrom: false                 
                };
            }
        }

        save(): any {
            if (this.note && this.isCoLocation) {
                this.note.isLocationFrom = this.note.isLocationFromAndTo;
                this.note.isLocationTo = this.note.isLocationFromAndTo;
            }
            if (this.isAdding) {               
                return this.dataService.customMethodData(`api/inventoryTransfer/${this.inventoryTransferId}/Note`, "POST", this.note)
                    .then((response) => {
                        //audit log
                        if (!this.preventUsageTracking) {
                            this.usageTrackingLog(Meevo.Model.NounEnum.InventoryTransferNote, Model.VerbEnum.SaveButtonClicked, null, this.inventoryTransferId);
                        }
                        return this.closeDialog(response.data);
                    });
            }

            else {
                return this.dataService.customMethodData(`api/inventoryTransfer/${this.inventoryTransferId}/Note`, "PUT", this.note)
                    .then((response) => {
                        //audit log
                        if (!this.preventUsageTracking) {
                            this.usageTrackingLog(Meevo.Model.NounEnum.InventoryTransferNote, Model.VerbEnum.SaveButtonClicked, null, this.inventoryTransferId);
                        }
                        return this.closeDialog(this.note.note);
                    });
            }
        }

        /*
        *   TRACKING 
        */
        usageTrackingLog(nounEnum, verbEnum, payload, mainEntityId): void {
            if (nounEnum !== null) {
                var trackingItem = new Meevo.Model.TrackingItem(nounEnum, verbEnum, payload, mainEntityId);
                this.trackingService.saveTrackingInfo(trackingItem);
            }
        }

        closeDialog(noteText: any): any {
            return this.$mdDialog.hide(noteText);
        }

    }

    angular.module("meevo.plugins.inventoryTransfer")
        .controller("meevo.plugins.inventoryTransfer.inventoryTransferNoteController", InventoryTransferNoteController);
}